import ReportingInfo from './container';

export default ReportingInfo;
